import apiService from './ApiService';

class AulaMensajesService {
  async getMensajes(aulaId, options = {}) {
    if (!aulaId) throw new Error('Aula requerida');
    const params = new URLSearchParams();
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.search) params.append('search', options.search);
    if (options.scope) params.append('scope', options.scope);
    const qs = params.toString();
    const resp = await apiService.get(`/aulas/${aulaId}/mensajes${qs ? `?${qs}` : ''}`);
    const items = resp?.items || resp?.Items || [];
    const list = Array.isArray(items) ? items : [];
    const total = resp?.total ?? resp?.Total ?? list.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items: list, total };
    }
    return list;
  }

  async crearMensaje(aulaId, payload) {
    if (!aulaId) throw new Error('Aula requerida');
    const resp = await apiService.post(`/aulas/${aulaId}/mensajes`, payload);
    if (resp && typeof resp.ok !== 'undefined' && !resp.ok) {
      const msg = resp.message || resp.error || resp.title || 'No pudimos crear el mensaje.';
      throw new Error(msg);
    }
    return resp;
  }

  async actualizarMensaje(aulaId, mensajeId, payload) {
    if (!aulaId || !mensajeId) throw new Error('Datos requeridos');
    const resp = await apiService.put(`/aulas/${aulaId}/mensajes/${mensajeId}`, payload);
    if (resp && typeof resp.ok !== 'undefined' && !resp.ok) {
      const msg = resp.message || resp.error || resp.title || 'No pudimos actualizar el mensaje.';
      throw new Error(msg);
    }
    return resp;
  }

  async eliminarMensaje(aulaId, mensajeId) {
    if (!aulaId || !mensajeId) throw new Error('Datos requeridos');
    const resp = await apiService.delete(`/aulas/${aulaId}/mensajes/${mensajeId}`);
    if (resp && typeof resp.ok !== 'undefined' && !resp.ok) {
      const msg = resp.message || resp.error || resp.title || 'No pudimos eliminar el mensaje.';
      throw new Error(msg);
    }
    return resp;
  }
}

const aulaMensajesService = new AulaMensajesService();
export default aulaMensajesService;
